// Beceri ve Eğilim Sınıflandırma Mini Testi
// [kavram, doğru kategori(ler), açıklama]
export const SKILL_CATEGORIES = [
  { key: "KB1", label: "KB1 · Temel Beceri" },
  { key: "KB2", label: "KB2 · Bütünleşik Beceri" },
  { key: "KB3", label: "KB3 · Üst Düzey Düşünme" },
  { key: "FBAB", label: "Fen Bilimleri Alan Becerisi" },
  { key: "E1", label: "E1 · Benlik Eğilimi" },
  { key: "E2", label: "E2 · Sosyal Eğilim" },
  { key: "E3", label: "E3 · Entelektüel Eğilim" },
];

export const SKILL_ITEMS = [
  ["Saymak", ["KB1"], "Karmaşık süreç gerektirmeyen, gözlenebilen eylem → temel beceri."],
  ["Ölçmek", ["KB1"], "Temel beceri örneğidir."],
  ["Çizmek", ["KB1"], "Temel beceri örneğidir."],
  ["Kaydetmek", ["KB1"], "Temel beceri örneğidir."],
  ["İşaret etmek", ["KB1"], "Temel beceri örneğidir."],
  ["Okumak", ["KB1"], "Temel beceri örneğidir."],
  ["Çelişki Giderme", ["KB2"], "KB2.1 – tutarsızlığı düzeltme çabası."],
  ["Özetleme", ["KB2"], "KB2.3 – özü kısaltarak kendi cümleleriyle aktarma."],
  ["Çözümleme", ["KB2"], "KB2.4 – bütünü parçalarına ayırma."],
  ["Bilgi Toplama", ["KB2"], "KB2.6 – elde etme, doğrulama, kaydetme."],
  ["Karşılaştırma", ["KB2"], "KB2.7 – benzerlik ve farklılıkları belirleme."],
  ["Genelleme", ["KB2"], "KB2.9 – ilişkilendirip genişleterek yargıya varma."],
  ["Çıkarım Yapma", ["KB2"], "KB2.10 – önerme ve varsayımlara dayalı sonuca ulaşma."],
  ["Yapılandırma", ["KB2"], "KB2.13 – uyumlu bir bütün oluşturma."],
  ["Yorumlama", ["KB2"], "KB2.14 – bağlamdan koparmadan kendi ifadesiyle açıklama."],
  ["Yansıtma", ["KB2"], "KB2.15 – deneyimi gelecek için gözden geçirme."],
  ["Değerlendirme", ["KB2"], "KB2.17 – ölçüte göre yargıda bulunma."],
  ["Tartışma", ["KB2"], "KB2.18 – görüş sunma, dinleme, mantıksal kıyaslama."],
  ["Mantıksal Denetleme", ["KB2"], "KB2.19 – akıl ilkelerine formel uygunluk."],
  ["Sentezleme", ["KB2"], "KB2.20 – ÖZGÜN bir bütün oluşturma."],
  ["Gözlemleme", ["KB2"], "KB2.2 – duyular aracılığıyla özellik belirleme. (Fen'deki karşılığı 'Bilimsel Gözlem'dir.)"],
  ["Mevcut Bilgiye/Veriye Dayalı Tahmin Etme", ["KB2"], "KB2.12 – eldeki verilerle hesaplama yaparak yargı."],
  ["Sınıflandırma", ["KB2", "FBAB"], "Hem KB2.5 bütünleşik beceri hem de FBAB2 Fen alan becerisidir; ikisi de doğru kabul edilir."],
  ["Tümevarımsal Akıl Yürütme", ["KB2", "FBAB"], "KB2.16.1 (Muhakemenin alt türü) ve FBAB10 olarak iki listede de yer alır."],
  ["Karar Verme", ["KB3"], "KB3.1 – üst düzey düşünme becerisi."],
  ["Problem Çözme", ["KB3"], "KB3.2 – üst düzey düşünme becerisi."],
  ["Eleştirel Düşünme", ["KB3"], "KB3.3 – üst düzey düşünme. (Eleştirel BAKMA ise E3 eğilimdir!)"],
  ["Hipotez Oluşturma", ["FBAB"], "Fen Bilimleri alan becerisidir; KB2 listesinde yoktur."],
  ["Deney Yapma", ["FBAB"], "Fen Bilimleri alan becerisidir."],
  ["Operasyonel Tanımlama", ["FBAB"], "Fen Bilimleri alan becerisidir."],
  ["Bilimsel Model Oluşturma", ["FBAB"], "Fen Bilimleri alan becerisidir."],
  ["Kanıt Kullanma", ["FBAB"], "Fen Bilimleri alan becerisidir."],
  ["Bilimsel Sorgulama", ["FBAB"], "Fen Bilimleri alan becerisidir (KB2.8 'Sorgulama' ile karıştırma)."],
  ["Bilimsel Veriye Dayalı Tahmin", ["FBAB"], "Fen Bilimleri alan becerisidir."],
  ["Merak", ["E1"], "Benlik eğilimidir."],
  ["Bağımsızlık", ["E1"], "Benlik eğilimidir."],
  ["Azim ve Kararlılık", ["E1"], "Benlik eğilimidir."],
  ["Kendine İnanma (Öz Yeterlilik)", ["E1"], "Benlik eğilimidir."],
  ["Kendine Güvenme (Öz Güven)", ["E1"], "Benlik eğilimidir."],
  ["Seçicilik", ["E1"], "Benlik eğilimidir."],
  ["Empati", ["E2"], "Sosyal eğilimdir."],
  ["Sorumluluk", ["E2"], "Sosyal eğilimdir (aynı zamanda çatı değerdir)."],
  ["Girişkenlik", ["E2"], "Sosyal eğilimdir."],
  ["Güven", ["E2"], "Sosyal eğilimdir."],
  ["Oyunseverlik", ["E2"], "Sosyal eğilimdir."],
  ["Odaklanma", ["E3"], "Entelektüel eğilimdir."],
  ["Yaratıcılık", ["E3"], "Entelektüel eğilimdir."],
  ["Gerçeği Arama", ["E3"], "Entelektüel eğilimdir."],
  ["Açık Fikirlilik", ["E3"], "Entelektüel eğilimdir."],
  ["Analitiklik", ["E3"], "Entelektüel eğilimdir."],
  ["Sistematiklik", ["E3"], "Entelektüel eğilimdir."],
  ["Soru Sorma", ["E3"], "Entelektüel eğilimdir."],
  ["Şüphe Duyma", ["E3"], "Entelektüel eğilimdir."],
  ["Eleştirel Bakma", ["E3"], "Entelektüel eğilimdir. (Eleştirel DÜŞÜNME ise KB3.3!)"],
];
